import React from 'react';
import { PorscheButtonProps } from './button.type';

/**
 * This react function create the porshe button component.
 * @param params PorscheButtonProps.
 * @returns the PorscheButton component.
 */
export const PorscheButton: React.FC<PorscheButtonProps> = ({
    onClick,
    label,
    id,
}) => {
    return (
        <button
            id={id}
            className='c-btn c-btn--icon c-btn--full u-pl-small@s'
            onClick={() => onClick()}
        >
            <i
                className='c-btn__icon
                                c-icon  c-icon--[semantic-arrow-right]
                                    '
                aria-hidden='true'
                role='img'
            ></i>
            <span className='c-btn__text u-ml-xsmall@s'>{label}</span>
        </button>
    );
};
